<template lang="pug">
  div.client-repuestos-section
    div.row-title.d-flex.pb-3
      b-icon-tools.mr-2.title
      h3.title Repuestos Solicitados
    //- N° De Serie Equipo en dos líneas
    .serie-section
      h4.data-label.rut N° De Serie Equipo
      h4.data-info {{ ovData.numero_serie_equipo }}
    //- Repuestos en cards horizontales (solo si hay repuestos)
    .repuestos-grid(v-if="ovData.repuestos && ovData.repuestos.length > 0")
      .repuesto-card(v-for="(repuesto, index) in ovData.repuestos" :key="index")
        h4.repuesto-title Repuesto {{ index + 1 }}
        .repuesto-content
          h4.data-label Categoría del Repuesto
          h4.data-info {{ repuesto.category ? repuesto.category.name : '-' }}
        .repuesto-content
          h4.data-label Comentario
          h4.data-info {{ repuesto.comments || '-' }}
    //- Comentario Cliente
    .comentario-section(v-if="ovData.comentario_cliente && ovData.comentario_cliente !== '-'")
      h4.data-label Comentario Cliente
      h4.data-info {{ ovData.comentario_cliente }}
</template>

<script>
export default {
  name: 'OVDetailRepuestosData',
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ovData() {
      return {
        numero_serie_equipo: this.ov.numero_serie_equipo || '-',
        comentario_cliente: this.ov.comentario_cliente || '-',
        repuestos: this.ov.repuestos || [],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.title {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
}

.repuesto-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}

.row-title {
  align-items: center;
}

.serie-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 0.5rem;
}

.data-label {
  font-size: 15px;
  font-weight: 700;
  text-align: left;
  color: #525252;
  margin: 0;
}

.rut {
  color: $blue-accent;
}

.data-info {
  font-size: 15px;
  font-weight: 400;
  color: #525252;
  text-align: left;
}

.client-repuestos-section {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
}

.comentario-section {
  padding: 0.5rem 0;
  margin-top: 0.5rem;
}

.repuestos-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 0.5rem;

  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
}

.repuesto-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0.5rem 0;
}

.repuesto-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
</style>
